import CtaSectionStyled from './CtaSectionStyled';
import PosaTemplate from './PosaTemplate';
import PropTypes from 'prop-types';
import React from 'react';

const CtaSection = ({data, ctaAction}) => {
  const {bgImage, cta, leftImage, rightContent} = data;

  return (
    <CtaSectionStyled className="ecr-ctaSection">
      <img className="bg-image" src={bgImage} alt="background" />
      <div className="ecrcs-left">
        <img src={leftImage} alt="asset" />
      </div>

      <div className="ecrcs-right">
        <div className="ecrcs-content">
          <PosaTemplate Tag="div" isTemplate string={rightContent} />
          <button onClick={ctaAction}>{cta.textOne}</button>
        </div>
      </div>
    </CtaSectionStyled>
  );
};

CtaSection.propTypes = {
  data: PropTypes.object,
  ctaAction: PropTypes.func,
};

export default CtaSection;
